import { render, staticRenderFns } from "./createInvoice.vue?vue&type=template&id=51b795b6&"
import script from "./createInvoice.vue?vue&type=script&lang=js&"
export * from "./createInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports